// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  TestPlanResults,
  TestPlanResultsFromJSON,
  TestPlanResultsToJSON,
  WebhookCustomFieldValue,
  WebhookCustomFieldValueFromJSON,
  WebhookCustomFieldValueToJSON,
} from "./";

/**
 *
 * @export
 * @interface WebhookTestPlanSnapshot
 */
export interface WebhookTestPlanSnapshot {
  /**
   *
   * @type {number}
   * @memberof WebhookTestPlanSnapshot
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof WebhookTestPlanSnapshot
   */
  title: string;
  /**
   *
   * @type {Array<WebhookCustomFieldValue>}
   * @memberof WebhookTestPlanSnapshot
   */
  customFields?: Array<WebhookCustomFieldValue>;
  /**
   *
   * @type {number}
   * @memberof WebhookTestPlanSnapshot
   */
  displayNumber?: number;
  /**
   *
   * @type {number}
   * @memberof WebhookTestPlanSnapshot
   */
  testPlanFolder?: number;
  /**
   *
   * @type {string}
   * @memberof WebhookTestPlanSnapshot
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof WebhookTestPlanSnapshot
   */
  endDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof WebhookTestPlanSnapshot
   */
  archived?: boolean;
  /**
   * Persisted plan status; failures are also identified by results, not status 3 alone. 4 is a legacy stored value shown as Archived; archiving itself sets the archived flag.
   * @type {number}
   * @memberof WebhookTestPlanSnapshot
   */
  status?: WebhookTestPlanSnapshotStatusEnum;
  /**
   * TCV-2175. The status as TestCollab shows it (0 Draft, 1 Ready to execute, 2 Finished, 3 Finished with failures, 4 Archived).
   * @type {string}
   * @memberof WebhookTestPlanSnapshot
   */
  statusLabel?: WebhookTestPlanSnapshotStatusLabelEnum;
  /**
   * TCV-2175. Derived from status and results. completed when status is 2 or 3; in_progress when at least one result is recorded and the plan is not completed; otherwise not_started. test_plan.status_changed fires only when the persisted status changes.
   * @type {string}
   * @memberof WebhookTestPlanSnapshot
   */
  progress?: WebhookTestPlanSnapshotProgressEnum;
  /**
   *
   * @type {TestPlanResults}
   * @memberof WebhookTestPlanSnapshot
   */
  results?: TestPlanResults;
}

export function WebhookTestPlanSnapshotFromJSON(
  json: any
): WebhookTestPlanSnapshot {
  return {
    id: json["id"],
    title: json["title"],
    customFields: !exists(json, "custom_fields")
      ? undefined
      : (json["custom_fields"] as Array<any>).map(
          WebhookCustomFieldValueFromJSON
        ),
    displayNumber: !exists(json, "display_number")
      ? undefined
      : json["display_number"],
    testPlanFolder: !exists(json, "test_plan_folder")
      ? undefined
      : json["test_plan_folder"],
    startDate: !exists(json, "start_date") ? undefined : json["start_date"],
    endDate: !exists(json, "end_date") ? undefined : json["end_date"],
    archived: !exists(json, "archived") ? undefined : json["archived"],
    status: !exists(json, "status") ? undefined : json["status"],
    statusLabel: !exists(json, "status_label")
      ? undefined
      : json["status_label"],
    progress: !exists(json, "progress") ? undefined : json["progress"],
    results: !exists(json, "results")
      ? undefined
      : TestPlanResultsFromJSON(json["results"]),
  };
}

export function WebhookTestPlanSnapshotToJSON(
  value?: WebhookTestPlanSnapshot
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    title: value.title,
    custom_fields:
      value.customFields === undefined
        ? undefined
        : (value.customFields as Array<any>).map(WebhookCustomFieldValueToJSON),
    display_number: value.displayNumber,
    test_plan_folder: value.testPlanFolder,
    start_date: value.startDate,
    end_date: value.endDate,
    archived: value.archived,
    status: value.status,
    status_label: value.statusLabel,
    progress: value.progress,
    results: TestPlanResultsToJSON(value.results),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum WebhookTestPlanSnapshotStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
  NUMBER_4 = 4,
}
/**
 * @export
 * @enum {string}
 */
export enum WebhookTestPlanSnapshotStatusLabelEnum {
  Draft = "Draft",
  ReadyToExecute = "Ready to execute",
  Finished = "Finished",
  FinishedWithFailures = "Finished with failures",
  Archived = "Archived",
}
/**
 * @export
 * @enum {string}
 */
export enum WebhookTestPlanSnapshotProgressEnum {
  NotStarted = "not_started",
  InProgress = "in_progress",
  Completed = "completed",
}
